import React from 'react'
import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'
import DesktopHero from '../../../static/images/fast-track/banner-img-desktop-opt1.jpg'
import MobileHero from '../../../static/images/fast-track/banner-img-mobile-opt1.jpg'
// import 'https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css'

const Container = styled.div`
  background-image:url(${MobileHero});
  background-repeat: no-repeat;
  background-position: center;
  position: relative;
  background-size: cover;
  text-align: center;
  margin: 0 auto;

  ${breakpoint('tablet')`
  background-image:url(${DesktopHero}) !important;
`}

  h1 {
    font-size: 2em;
    color: white;
    margin: 0 0 0.3em;
  }

  h2 {
    font-size: 1.2em;
    font-weight: 400;
    color: ${props => props.theme.colors.grisOscuro};
    margin: 0 0 0.5em;
  }

  h3 {
    color: white;
    font-size: 19px;
    font-weight: 500;
    letter-spacing: 0.5px;
    margin-bottom:20px;
  }

  span {
    color:white;
    font-size:11px;
    letter-spacing: 0.5px;
    font-weight: 200;
  }

  input {
    background: transparent;
    color: white;
    text-align: left;
    width: 60%;
    height: 50px;
    padding: 0 18px;
    border: 0.5px solid white;

  }

  input::placeholder {
    color: white;
    font-weight:300;
    letter-spacing:1px;
    font-size:15px;
  }

  p {
    color: white;
    margin-bottom: 0 0 1.5em;
    width: 100%;
    font-size: 22px !important;
    font-weight: 300;
    letter-spacing: 0.5px;

    ${breakpoint('tablet')`
    width: 80%;
    `}
  }

  ${breakpoint('desktop')`
    h1{
      font-size: 3em;
    }

    h2{
      font-size: 2em;
    }

    a {
      font-size: 1.3em;
    }
  `}

  video {
    max-width: 100%;
  }
`

const DivText = styled.div`
    margin-top:280px;

    ${breakpoint('tablet')`
      margin-top:50px;
      margin-bottom:50px;
    `}
`

const Wrapper = styled.div`
  padding: 3em 2em;
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  box-sizing: border-box;

  ${breakpoint('tablet')`
    display: flex;
    text-align: left;
    justify-content: center;

    & > div {
      flex-grow: 0;
      flex-shrink: 0;
      flex-basis: 50%;
      max-width: 500px;
      box-sizing: border-box;
    }

    & > div:first-of-type {
      padding-right: 20px;
    }
  `}
`

const H1 = styled.h1 `
    margin-top: -7 !important;
    font-weight: 800;
    color: white !important;
    font-size: 2.7em !important;
`

const ButtonConsulta = styled.a `
    font-size: 15px !important;
    color: white;
    background: transparent;
    border: 1px solid white;
    font-weight:300;
    letter-spacing:1px;
    text-decoration:none;
    padding: 15px 10px;
    display: inline-block;
    margin-top: 10px;
    margin-left: 0;

    &:hover {
        text-decoration:none;
        color: #ffffff;
        background: #ffffff42;
    }
`

const Header = ({ formUrl, multicanalidad, pais }) => (
  <Container>
    <Wrapper>
      <DivText>
        <H1> ¡Ya estamos en feria!</H1>
        <H1>Comprá tu carro hoy</H1>
        <p>Podés hacerlo todo a un solo clic y sin filas por medio de nuestros canales digitales</p>
        <ButtonConsulta href="https://www.baccredomatic.com/es-cr/prestamos/vehiculos/nuevo/solicitud">Comprá tu carro nuevo</ButtonConsulta><br></br>
      </DivText>
      <div>

      </div>
    </Wrapper>
  </Container>
);
export default Header